import Bugsnag from "@bugsnag/js";


/*
 * Interface to trace error to an external tool
 *
 * @param error {string}
 * @return {void}
 */
export function notifyError(error: string):void {
    if (Bugsnag?.isStarted()) {
        Bugsnag.notify(error)
    }
}